import { render, staticRenderFns } from "./TermList.vue?vue&type=template&id=1516f1fd&scoped=true&"
import script from "./TermList.vue?vue&type=script&lang=ts&"
export * from "./TermList.vue?vue&type=script&lang=ts&"
import style0 from "./TermList.vue?vue&type=style&index=0&id=1516f1fd&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1516f1fd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/intern/customer-portal/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib'
installComponents(component, {VDataTable})
